export default __webpack_public_path__ + "static/media/Cairo-ExtraBold.525770a0.ttf";